﻿export function FormatSGForDisplay(val, showPlato) {

    if (typeof showPlato == 'undefined') {
        showPlato = false;
    }

    if (val == null || val === 0) {
        return 0.000;
    }

    if (showPlato) {
        return ((-1 * 616.868) + (1111.14 * val) - (630.272 * Math.pow(val,2)) + (135.997 * Math.pow(val,3))).toFixed(2) + ' °P';
    }

    return val.toFixed(3) + " SG";
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/recipeDisplayHelpers.js
// module id = 167
// module chunks = 0 1 6